/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

export default (props) => {
  const { onClick, isReadOnly = false } = props;
  const selectedParentInd = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.selectedParentInd
  );
  return (
    <div className='tdCell icon-btn-group text-black d-flex mh-100 h-100 align-items-center'>
      <OverlayTrigger
        placement='bottom'
        overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
      >
        <Button
          data-testid='deleteBtn'
          className='th-ic trash-blue'
          variant='text'
          disabled={!!(selectedParentInd === '1') || isReadOnly}
          onClick={() => props.onClick(props)}
          aria-label='Delete'
        >
          <SVGComponent iconName='Icon-delete' />
        </Button>
      </OverlayTrigger>
    </div>
  );
};
